import React from "react";
import ReactDOM from "react-dom/client";
import App from '@app/index';
import { installGlobalErrorHandlers } from "@app/utils/globalErrorHandlers";
import { applyDensity, isCondensedStored } from "@app/utils/densityPreference";
import { applyTheme, isDarkThemeStored } from "@app/utils/themePreference";

// Installed before the first render so nothing can escape unreported
installGlobalErrorHandlers();

// Applied before the first render, otherwise a stored preference shows a flash of
// the light theme, or of full spacing, while React mounts.
applyTheme(isDarkThemeStored());
applyDensity(isCondensedStored());

const root = ReactDOM.createRoot(document.getElementById("root") as Element);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
